// https://medium.com/tinyso/how-to-detect-inactive-user-to-auto-logout-by-using-idle-timeout-in-javascript-react-angular-and-b6279663acf2
class IdleTimer {
  constructor({ timeout, onTimeout, onRefresh }) {
    this.timeout = timeout;
    this.onTimeout = onTimeout;
    this.onRefresh = onRefresh;

    const expiredTime = parseInt(sessionStorage.getItem('_expiredTime'), 10);
    // if (expiredTime > 0 && expiredTime < Date.now()) {
    //   onExpired();
    //   return;
    // }
    this.timedOut = expiredTime > 0 && expiredTime < Date.now();

    // this.eventHandler = this.updateExpiredTime.bind(this);
    this.eventHandler = () => {
      if (this.onRefresh && this.timedOut) {
        this.onRefresh();
        this.timedOut = false;
      }
      this.updateExpiredTime();
    };
    this.tracker();
    this.startInterval();
  }

  startInterval() {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      const expiredTime = parseInt(sessionStorage.getItem('_expiredTime'), 10);
      if (expiredTime < Date.now()) {
        if (this.onTimeout && !this.timedOut) {
          const success = this.onTimeout();
          if (success) {
            this.timedOut = true;
          } else {
            this.updateExpiredTime();
          }
          // this.cleanUp();
        }
      }
    }, 1000);
  }

  updateExpiredTime() {
    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }
    this.timeoutTracker = setTimeout(() => {
      sessionStorage.setItem('_expiredTime', Date.now() + this.timeout * 1000);
    }, 300);
  }

  tracker() {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }

  cleanUp() {
    // sessionStorage.removeItem("_expiredTime");
    clearInterval(this.interval);
    window.removeEventListener('mousemove', this.eventHandler);
    window.removeEventListener('scroll', this.eventHandler);
    window.removeEventListener('keydown', this.eventHandler);
  }
}
export default IdleTimer;
